/**
 *
 * Asynchronously loads the component for RegisterPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
